import { render, staticRenderFns } from "./routinePdf.vue?vue&type=template&id=3c36fea8&scoped=true&"
import script from "./routinePdf.vue?vue&type=script&lang=js&"
export * from "./routinePdf.vue?vue&type=script&lang=js&"
import style0 from "./routinePdf.vue?vue&type=style&index=0&id=3c36fea8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c36fea8",
  null
  
)

export default component.exports